// extracted by mini-css-extract-plugin
module.exports = {"container":"answersList_container__ppFgQ"};